export const PriceAnchorStrip = () => (
  <section className="bg-[#2C2B2C] py-12 md:py-24" data-testid="price-anchor">
    <div className="mx-auto max-w-4xl px-6 text-center">
      <span className="inline-flex items-center rounded-full bg-[#F2E8E6] px-3.5 py-1 text-[0.62rem] font-semibold uppercase tracking-[0.22em] text-[#232222]">The Smart Maths</span>
      <h2 className="mt-4 font-display text-2xl font-light leading-tight text-[#FFFCFA] sm:mt-5 sm:text-4xl">
        One mask. <span className="text-[#FBC4A8]">A lifetime</span> of salon-grade glow.
      </h2>
      <div className="mt-7 grid grid-cols-3 divide-x divide-white/10 sm:mt-12">
        {[
          ["$200+", "per single salon LED facial", true],
          ["$0.71", "a day over a year of glow", false],
          ["10 min", "from your own bathroom", false],
        ].map(([big, small, strike], i) => (
          <div key={i} className="px-2 py-2 sm:px-6">
            <p className={`font-display text-2xl sm:text-5xl ${strike ? "text-[#A0928C] line-through" : "text-[#FBC4A8]"}`}>{big}</p>
            <p className="mt-1.5 text-[0.7rem] font-light leading-snug text-[#F2E8E6] sm:mt-2 sm:text-sm">{small}</p>
          </div>
        ))}
      </div>
      <p className="mt-7 text-[0.8rem] font-light text-[#9A8E88] sm:mt-10 sm:text-sm">
        The Leopard Luxe™ pays for itself in roughly <span className="font-medium text-[#FFFCFA]">3 salon visits</span>, then keeps glowing for years.
      </p>
    </div>
  </section>
);
